// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading_loadingWrapper__1Bu_A"};